<template>
  <div>
    <EchartMap
      :options="options"
      id="centerLeftMap"
      height="600px"
      width="100%"
      v-if="showMap"
    ></EchartMap>
  </div>
</template>

<script>
import EchartMap from '@/common/echartMap';
// import mapJson from './qingpu.js';
import { startPoint, generateMoveLine } from './mapPoints';
export default {
  data() {
    return {
      options: {},
      showMap: false // 控制地图显示
    };
  },
  components: {
    EchartMap
  },
  props: {
    name: {
      type: String,
      default: 'china' // 默认地图名称
    },
    cdata: {
      type: Object,
      default: () => ({})
    }
  },
  created() {
    this.loadMapJson(this.name);
    // this.$echarts.registerMap('area', mapJson);
  },
  computed: {
    isShowLine() {
      return this.name === 'qingpu';
    }
  },
  mounted() {},
  watch: {
    cdata: {
      handler(datas) {
        const moveLine = generateMoveLine();

        this.options = {
          // tooltip: {
          //   show: true,
          //   formatter: function (params) {
          //     return params.name + '<br>' + params.value;
          //   }
          // },
          tooltip: {
            show: false,
            enterable: true, //鼠标可进入浮层内
            // triggerOn: "click", // 点击触发
            backgroundColor: '#0A1531',
            padding: 10,
            extraCssText:
              'padding:30px 70px;box-shadow: inset 0px 0px 10px 0px #00b6ff;border-radius:0px;opacity: 0.8;border:1px solid rgba(0, 182, 255, 0.8);',
            textStyle: {
              color: 'red'
            },
            formatter: function (params) {
              return `
              <ul class="map-tooltip">
                <li class="title">${params.name}
                  <span>${
                    (datas[params.name] && datas[params.name].school) || ''
                  }</span>
                  </li>
                <li>学生数量：
                  <span>${
                    (datas[params.name] && datas[params.name].studentNum) || 0
                  }</span>
                </li>
                <li>资源教师：
                  <span>${
                    (datas[params.name] && datas[params.name].teacherNum) || 0
                  }</span>
                </li>
                <li>地址：
                  <span>${
                    (datas[params.name] && datas[params.name].address) || ''
                  }</span>
                </li>
                <li>活跃度排名：
                  <span class="color">${
                    (datas[params.name] && datas[params.name].rank) || ''
                  }</span>
                </li>
              </ul>
            `;
              // <span class="color">第${
              //     (datas[params.name] && datas[params.name].rank) || 0
              //   }名</span>
            }
          },
          grid: {
            left: '0%',
            right: '0%',
            top: '0%',
            bottom: '0%',
            show: false
            // backgroundColor: '#000'
          },
          // 地图的阴影底图
          geo: {
            map: 'area',
            left: 0,
            right: 0,
            bottom: 0,
            top: 0,
            aspectScale: 0.9,
            layoutCenter: ['50%', '50%'], //地图位置
            layoutSize: '96%',
            itemStyle: {
              normal: {
                shadowColor: 'rgba(0,228,242,0.5)',
                shadowBlur: 5,
                color: '#082A52'
              },
              emphasis: {
                areaColor: '#082A52'
              }
            },
            z: 2
          },
          //就这东西能根据地图数据value值实现地图不同颜色
          visualMap: {
            show: false,
            max: 100,
            seriesIndex: [3],
            inRange: {
              color: ['#A5DCF4', '#006edd']
            }
          },
          series: [
            {
              type: 'map',
              map: 'area',
              aspectScale: 0.9,
              layoutCenter: ['50%', '50%'], //地图位置
              layoutSize: '95%',
              label: {
                normal: {
                  show: true,
                  fontFamily: 'SourceHanSansCN',
                  fontSize: '14',
                  color: '#FEFEFE'
                },
                emphasis: {
                  show: true,
                  fontFamily: 'SourceHanSansCN',
                  fontSize: '14',
                  color: '#FEFEFE'
                }
              },
              itemStyle: {
                normal: {
                  borderColor: 'rgba(0,0,0, 0.6)',
                  borderWidth: 0.8,
                  areaColor: {
                    type: 'linear-gradient',
                    x: 0,
                    y: 300,
                    x2: 0,
                    y2: 0,
                    colorStops: [
                      {
                        offset: 0,
                        color: '#0a56BC' // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: '#12A6F2'
                      }
                    ],
                    global: true // 缺省为 false
                  }
                },
                emphasis: {
                  shadowColor: 'rgba(0, 0, 0, 1)',
                  shadowBlur: 10,
                  shadowOffsetX: 5,
                  shadowOffsetY: 5,
                  areaColor: {
                    type: 'linear-gradient',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: '#F5B615' // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: '#E27B0d'
                      }
                    ]
                  }
                }
              },
              zlevel: 1
            },
            {
              name: '线路',
              type: 'lines',
              coordinateSystem: 'geo',
              zlevel: 2,
              large: true,
              effect: {
                show: true,
                constantSpeed: 30,
                symbol: 'arrow', //ECharts 提供的标记类型包括 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow'
                symbolSize: 0,
                trailLength: 0
              },
              lineStyle: {
                normal: {
                  color: '#f3c824',
                  width: 2,
                  opacity: 1.0,
                  curveness: 0.15
                }
              },
              data: this.isShowLine ? moveLine : []
            },
            {
              name: 'Points',
              type: 'effectScatter',
              coordinateSystem: 'geo',
              data: this.isShowLine
                ? [
                    {
                      name: startPoint.name,
                      value: [...startPoint.coords, 200] // 添加一个虚拟值用于显示大小
                    }
                  ]
                : [],
              symbolSize: function (val) {
                return val[2] / 10;
              },
              showEffectOn: 'render',
              rippleEffect: {
                brushType: 'stroke'
              },
              hoverAnimation: true,
              label: {
                normal: {
                  formatter: '{b}',
                  position: 'left',
                  fontSize: 16,
                  show: true
                }
              },
              itemStyle: {
                normal: {
                  color: '#F4E925',
                  shadowBlur: 10,
                  shadowColor: '#05C3F9'
                }
              },
              zlevel: 1
            }
          ]
        };
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    async loadMapJson(mapName) {
      try {
        this.showMap = false; // 在加载前先隐藏地图
        // 动态加载地图 JSON 文件
        const response = await fetch(`/map/${mapName}.json`);
        const mapData = await response.json();
        this.showMap = true; // 加载完成后显示地图
        this.$echarts.registerMap('area', mapData);
      } catch (error) {
        console.error(`加载地图数据失败: ${mapName}`, error);
      }
    }
  }
};
</script>

<style lang="scss">
// 提示框style
.map-tooltip {
  list-style: none;
  font-size: 20px;
  font-weight: 400;
  color: #ffffff;
  li.title {
    font-size: 24px;
  }
  li {
    line-height: 40px;
    .color {
      color: #ffcc00;
    }
  }
}
</style>